import React, { forwardRef, useMemo } from 'react';
import { Select } from 'antd';

const TierSelect = forwardRef(({ tiers, onChange, value }, ref) => {
	if (!tiers) {
		return null;
	}

	return (
		<Select mode='single' optionFilterProp='label' onChange={onChange} value={value} ref={ref}>
			{tiers.map((tier) => (
				<Select.Option key={tier.id} value={tier.id} label={tier.quota}>
					{tier.quota}
				</Select.Option>
			))}
		</Select>
	);
});

export default TierSelect;



// WEBPACK FOOTER //
// ./src/components/TierSelect.jsx